export class QueryStringHelpers {
    
    public static get(key: string) {
        key = key.toLowerCase();
        key = key.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + key + '=([^&#]*)');
        var results = regex.exec(location.search.toLowerCase());
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
}